import * as cn from "./Demand.scss"
import {User} from "./../model/User"
import {SummaryRow, yearColumns, employeeAvg, employeeYear} from "./Final"
import {Demand as DemandModel, DemandByYear, DemandList} from "../model/Demand";
import {getCompany, getSpeciality, getUniversityBranch} from "../model/utils/utils";
import {Divisions} from "../model/Division";
import {Specialities, Speciality} from "../model/Speciality";
import {UniversityBranch, UniversityBranches} from "../model/UniversityBranch";
import {Employee, Fired} from "../model/Employee";
import {EMPLOYEE_YEAR, VACANCY_YEARS} from "../Demand/common";
import * as React from "react";
import {Footer} from "./Footer";

export enum Type {
    Demand,
    Target,
    TraineeDemand,
}

type Props = {
    demand: DemandList
    divisions: Divisions
    specialities: Specialities
    universityBranches: UniversityBranches
    user: User
    company: string
    total: SummaryRow
    totalNuclear: SummaryRow
    totalAesProjects: SummaryRow
    type: Type
    order: number
}

type RowProps = {
    demandByYear: DemandByYear
    employeeCurrentYear: number
    employeeCurrentYearGpa: number
    speciality: Speciality
    universityBranch: UniversityBranch
    company: {
        company: string
    }
}

export class Row extends React.PureComponent<RowProps> {
    render() {
        const {
            demandByYear,
            employeeCurrentYear,
            employeeCurrentYearGpa,
            speciality: {
                title: speciality,
                category,
                code,
            },
            universityBranch: {
                abbreviation: university,
            },
            company: {
                company,
            },
        } = this.props

        return (
            <tr className = {cn.row}>
                <td className = {cn.cell}>{company}</td>
                <td className = {cn.cell}>{category}</td>
                <td className = {cn.cell}>{code + " — " + speciality}</td>
                <td className = {cn.cell}>{employeeCurrentYear}</td>
                <td className = {cn.cell}>{employeeCurrentYearGpa ? employeeCurrentYearGpa.toFixed(2).replace(".", ",") : ""}</td>
                {yearColumns.map(year => <td {...{key: year}} className = {cn.cell}>{demandByYear[year] || ""}</td>)}
                <td className = {cn.cell + " " + cn.cellUniversity}>{university}</td>
            </tr>
        )
    }
}

export class Demand extends React.PureComponent<Props> {
    render() {
        const {demand, company, user, divisions, specialities, universityBranches, total, totalNuclear, totalAesProjects, type, order} = this.props

        return (
            <div className = {cn.component}>
                <div className = {cn.page}>
                    <br/>
                    <div className = {cn.heading}>
                        {(type === Type.Target) ? (
                            <div className = {cn.title}>
                                Данные о трудоустройстве и потребностях организации Госкорпорации «Росатом»
                                <br/>
                                в выпускниках образовательных организаций, обучающихся по программе целевого обучения,  в том числе для предприятий ОПК
                                <br/>
                                Приложение № {order}
                            </div>
                        ) : (
                            <div className = {cn.title}>
                                Данные о трудоустройстве и потребностях
                                <br/>
                                организации Госкорпорации «Росатом» в выпускниках образовательных организаций
                                <br/>
                                Приложение № {order}
                            </div>
                        )}
                        <div className = {cn.meta}>
                            <div className = {cn.label}>Организация:</div><div className = {cn.value}>{company}</div>
                        </div>
                        <div className = {cn.meta}>
                            <div className = {cn.label}>Дата заполнения:</div>
                            <div className = {cn.value}>
                                {("0" + new Date().getDate()).slice(-2) + "." + ("0"+(new Date().getMonth()+1)).slice(-2) + "." + new Date().getFullYear()}
                            </div>
                        </div>
{/*
                        <div className = {cn.meta}>
                            <div className = {cn.label}>Ответственный:</div><div className = {cn.value}>{user.executor.fullName}</div>
                        </div>
*/}
                    </div>
                    <br/>
                    <br/>
                    <table className = {cn.table} cellPadding = {0} cellSpacing = {0}>
                        <colgroup>
                            {Array.apply(null, Array(yearColumns.length + 6)).map((_, key, array) => (
                                <col {...{key}} className = {cn.column + (key === array.length - 1 ? " " + cn.columnUniversity : "")}/>)
                            )}
                        </colgroup>
                        <thead className = {cn.head}>
                        <tr className = {cn.headRow}>
                            <td className = {cn.headCell} rowSpan = {3}>Предприятие</td>
                            <td className = {cn.headCell} rowSpan = {3}>УО</td>
                            <td className = {cn.headCell} rowSpan = {3}>Направление подготовки/Специальность</td>
                            <td className = {cn.headCell} colSpan = {yearColumns.length + 2}>Количество вакансий</td>
                            <td className = {cn.headCell} rowSpan = {3}>Образовательная организация</td>
                        </tr>
                        <tr className = {cn.headRow}>
                            <td className = {cn.headCell} colSpan = {2}>Факт</td>
                            <td className = {cn.headCell} colSpan = {VACANCY_YEARS.length}>План</td>
                            <td className = {cn.headCell} colSpan = {yearColumns.length - VACANCY_YEARS.length}>Прогноз</td>
                        </tr>
                        <tr className = {cn.headRow}>
                            <td className = {cn.headCell}>{EMPLOYEE_YEAR} (т)</td>
                            <td className = {cn.headCell}>ср. балл</td>
                            {yearColumns.map(year => <td className = {cn.headCell} key = {year}>{year - 2000}</td>)}
                        </tr>
                        </thead>
                        <tbody>
                        {demand.map((demand: DemandModel) => {
                            if (type === Type.Target) {
                                if (demand.targetTotal) {
                                    const employees = demand.employees.filter(({target, demandYear, fired}: Employee) => target && demandYear === EMPLOYEE_YEAR && fired !== Fired.Fired)

                                    return <Row {...{
                                        key: demand.id,
                                        demandByYear: demand.targetByYear,
                                        employeeCurrentYear: employees.size,
                                        employeeCurrentYearGpa: employees.size && employees.reduce((r: number, {gpa}: Employee) => r + gpa, 0) / employees.size,
                                        company: getCompany(divisions, demand.companyId),
                                        speciality: getSpeciality(specialities, demand.specialityId),
                                        universityBranch: getUniversityBranch(universityBranches, demand.universityBranchId),
                                    }}/>
                                }
                            } else {
                                if (demand.demandTotal) {
                                    const employees = demand.employees.filter(({fired}: Employee) => fired !== Fired.Fired)

                                    return <Row {...{
                                        key: demand.id,
                                        demandByYear: demand.demandByYear,
                                        employeeCurrentYear: employees.size,
                                        employeeCurrentYearGpa: employees.size && employees.reduce((r: number, {gpa}: Employee) => r + gpa, 0) / employees.size,
                                        company: getCompany(divisions, demand.companyId),
                                        speciality: getSpeciality(specialities, demand.specialityId),
                                        universityBranch: getUniversityBranch(universityBranches, demand.universityBranchId),
                                    }}/>
                                }
                            }
                        }).toList()}
                        <tr className = {cn.rowTotal}>
                            <td className = {cn.cellTotal}>Итого:</td>
                            <td className = {cn.cellTotal}/>
                            <td className = {cn.cellTotal}/>
                            <td className = {cn.cellTotal}>{total[employeeYear] || ""}</td>
                            <td className = {cn.cellTotal}>{total[employeeYear] ? (total[employeeAvg] / total[employeeYear]).toFixed(2).replace(".", ",") : ""}</td>
                            {yearColumns.map(year => <td {...{key: year}} className = {cn.cellTotal}>{total[year] || 0}</td>)}
                            <td className = {cn.cellTotal + " " + cn.cellTotalUniversity}/>
                        </tr>
                        <tr className = {cn.rowTotal}>
                            <td className = {cn.cellTotal}>в т.ч. по ядерным специальностям:</td>
                            <td className = {cn.cellTotal}/>
                            <td className = {cn.cellTotal}/>
                            <td className = {cn.cellTotal}>{totalNuclear[employeeYear] || ""}</td>
                            <td className = {cn.cellTotal}>{totalNuclear[employeeYear] ? (totalNuclear[employeeAvg] / totalNuclear[employeeYear]).toFixed(2).replace(".", ",") : ""}</td>
                            {yearColumns.map(year => <td {...{key: year}} className = {cn.cellTotal}>{totalNuclear[year] || 0}</td>)}
                            <td className = {cn.cellTotal + " " + cn.cellTotalUniversity}/>
                        </tr>
{/*
                        <tr className = {cn.rowTotal}>
                            <td className = {cn.cellTotal}>в т.ч. по проектам сооружения АЭС:</td>
                            <td className = {cn.cellTotal}/>
                            <td className = {cn.cellTotal}/>
                            <td className = {cn.cellTotal}>{totalAesProjects[employeeYear] || ""}</td>
                            <td className = {cn.cellTotal}>{totalAesProjects[employeeYear] ? (totalAesProjects[employeeAvg] / totalAesProjects[employeeYear]).toFixed(2).replace(".", ",") : ""}</td>
                            {yearColumns.map(year => <td {...{key: year}} className = {cn.cellTotal}>{totalAesProjects[year] || 0}</td>)}
                            <td className = {cn.cellTotal + " " + cn.cellTotalUniversity}/>
                        </tr>
*/}
                        </tbody>
                    </table>
                </div>
                <Footer user={user}/>
            </div>
        )
    }
}